import { Icon } from "armstrong-react";
import React from "react";
import { Link } from "react-router";

import { StarRating } from "../../../../core/atoms/atoms";

export class ArchiveRatingFragment extends React.PureComponent<{ rating: number, ltoName: string, fragment: string}> {
  public render() {
    const hasRating = this.props.rating != null;

    const title = hasRating
      ? `On average, customers rated ${this.props.ltoName} ${this.props.rating}/5 ${this.props.fragment}`
      : `${this.props.ltoName} has not received any ratings ${this.props.fragment}`;

    return (
      <div className="segment-avg" title={title}>
        <div className="rating-wrap">
          {hasRating && <StarRating maximumValue={5} currentValue={this.props.rating} title={null} />}
          {!hasRating && <Icon className="no-rating" icon={Icon.Icomoon.minus3} />}
        </div>
        {this.props.children}
      </div>
    );
  }
}
